/**
 * Plano ilustrativo do estado vazio do módulo "Plano alimentar". Nada aqui é
 * do paciente: só mostra o que o profissional ganha ao montar o primeiro plano.
 */
export const EXAMPLE_MEALS = [
  {
    key: 'ex-m1',
    name: 'Café da manhã',
    time: '07:30',
    note: '',
    items: [
      { key: 'ex-i1', food: 'Pão integral', portion: '2', unit: 'fatias', note: '', substitutes: [{ key: 'ex-s1', food: 'Tapioca', portion: '1', unit: 'unidade' }] },
      { key: 'ex-i2', food: 'Ovo mexido', portion: '2', unit: 'unidades', note: 'Sem óleo', substitutes: [] },
      { key: 'ex-i3', food: 'Café com leite desnatado', portion: '1', unit: 'xícara', note: '', substitutes: [] },
    ],
  },
  {
    key: 'ex-m2',
    name: 'Almoço',
    time: '12:30',
    note: 'Comece pela salada',
    items: [
      { key: 'ex-i4', food: 'Arroz integral', portion: '4', unit: 'colheres de sopa', note: '', substitutes: [{ key: 'ex-s2', food: 'Batata-doce', portion: '150', unit: 'g' }] },
      { key: 'ex-i5', food: 'Feijão', portion: '1', unit: 'concha', note: '', substitutes: [] },
      { key: 'ex-i6', food: 'Frango grelhado', portion: '120', unit: 'g', note: '', substitutes: [{ key: 'ex-s3', food: 'Peixe assado', portion: '150', unit: 'g' }] },
      { key: 'ex-i7', food: 'Salada de folhas e legumes', portion: '1', unit: 'prato de sobremesa', note: 'Azeite e limão', substitutes: [] },
    ],
  },
  {
    key: 'ex-m3',
    name: 'Lanche da tarde',
    time: '16:00',
    note: '',
    items: [
      { key: 'ex-i8', food: 'Iogurte natural', portion: '1', unit: 'pote', note: '', substitutes: [] },
      { key: 'ex-i9', food: 'Fruta', portion: '1', unit: 'unidade', note: 'Maçã, pera ou banana', substitutes: [] },
    ],
  },
];

export const EXAMPLE_GUIDELINES = 'Beba de 2 a 2,5 litros de água ao longo do dia. Evite refrigerantes e sucos industrializados.';
